import React from 'react';
import { FaLinkedin, FaGithub, FaTwitter, FaEnvelope } from 'react-icons/fa';
import { saveAs } from 'file-saver';
import { motion } from 'framer-motion'; // Import motion from framer-motion
import resume from '../Pdfs/Anurag Gaiwal Resume.pdf';

const Contact = () => {
  
  const handleDownloadResume = (event) => {
    event.preventDefault();
    saveAs(resume, "Anurag Gaiwal Resume");
  };

  return (
    <>
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 md:px-8 lg:px-16" id="contact">
        <h1 className="text-2xl md:text-4xl font-bold mb-8">Contact Me</h1>
        <motion.div 
          className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0 items-center justify-center"
          initial={{ opacity: 0, y: 50 }} // Initial animation state (hidden and slightly moved up)
          whileInView={{ opacity: 1, y: 0 }} // Animation when component mounts (visible and moves down to its place)
          transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
        >
          <a
            href="https://mail.google.com/mail/u/0/#inbox?compose=new"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded w-full md:w-auto justify-center"
          >
            <FaEnvelope className="mr-2" />
            anuraggaiwal0@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/anurag-gaiwal/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-full md:w-auto justify-center"
          >
            <FaLinkedin className="mr-2" />
            LinkedIn
          </a>
          <a
            href="https://github.com/Anurag-Gaiwal"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-gray-800 hover:bg-gray-900 text-white font-bold py-2 px-4 rounded w-full md:w-auto justify-center"
          >
            <FaGithub className="mr-2" />
            GitHub
          </a>
          <a
            href="https://x.com/anuraggaiwal"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center bg-blue-400 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded w-full md:w-auto justify-center"
          >
            <FaTwitter className="mr-2" />
            Twitter
          </a>
          <motion.button
            onClick={handleDownloadResume}
            className="flex items-center bg-blue-600 hover:bg-blue-900 text-white font-bold py-2 px-4 rounded w-full md:w-auto justify-center"
          >
            Download Resume
          </motion.button>
        </motion.div>
      </div>
    </>
  );
  
};

export default Contact;
